import React, { Fragment } from 'react'
import { Route } from 'react-router-dom';
import { EmployeeCardSuspendFiltering } from './Pages';

export const EmployeeCardSuspendRoutes = ({ match }) => (
    <Fragment>
        <Route exact path={`${match.path}`} component={EmployeeCardSuspendFiltering} />
    </Fragment>
)